module.exports = __webpack_public_path__ + "img/step-line-enable.2454675b.svg";